import React, { Component } from 'react'
import { Input, Row, Col } from 'antd'

class PrivilegeInput extends Component {
  state = {
    firstName: '',
    lastName: ''
  }
  handleChange = (e) => {
    const { onChange, privilegeKeys } = this.props
    this.setState({
      [e.target.name]: e.target.value
    }, () => {
      const { firstName, lastName } = this.state
      onChange({
        firstName,
        lastName,
        privilegeKeys
      })
    })
  }
  render () {
    // const { onChange, privilegeKeys } = this.props
    const {
      firstName, lastName
    } = this.state
    return <Row gutter={8}>
      <Col span={12}>
        <Input defaultValue={firstName} onChange={this.handleChange} name="firstName" />
      </Col>
      <Col span={12}>
        <Input defaultValue={lastName} onChange={this.handleChange} name="lastName" />
      </Col>
    </Row>
  }
}

export default PrivilegeInput



// WEBPACK FOOTER //
// ./src/App/components/PrivilegeInput/PrivilegeInput.js